import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Preference } from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Step3 } from '../../../../shared/models/component-messages/simp_in/step3';
import { TypeObjCPV } from '../models/TypeObjCPV';
@Component({
  selector: 'app-type-objCPV',
  templateUrl: './type-objCPV.component.html'
})
export class TypeObjCPVComponent implements OnInit {
  @Input() uid = '';
  public current_uid = 'TypeObjCPV';
  @Input() parentForm: FormGroup;

  @Input() disabled: boolean;
  @Input() codeCPV: TypeObjCPV;
  @Input() i: number;

  @Output() prefEmit: EventEmitter<Preference> = new EventEmitter();

  public step3 = new Step3();

  constructor() { }

  public ngOnInit() { }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  chargeDonneePreference(preference: Preference) {
    this.prefEmit.emit(preference);
  }
}
